module.exports = __webpack_public_path__ + "static/logo-v2-83e4d0c783ecb6d8153b3ea0a9f87bbf.png";